import BossModel from "@/models/BossModel";
import MediaLibraryItem from "@/models/Media/Library/Item/MediaLibraryItem";

export default class MediaLibraryDocument extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'media-library-item/document';

    /**
     *
     * @type {string}
     */
    static entity = 'mediaLibraryDocuments';

    static fields() {
        return {
            id: this.number(null).nullable(),
            media_library_item_id: this.number(null).nullable(),
            is_usable: this.boolean(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    /**
     *
     * @param name
     * @param parentId
     * @returns {Promise<AxiosResponse<T>>}
     */
    static create(name, parentId = null) {
        return this.api().create({name: name, media_library_folder_parent_id: parentId});
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    update(){
        return this.api().update();
    }

    /**
     *
     * @param folderIds
     * @param folderId
     * @returns {Promise<AxiosResponse<T>>}
     */
    static multiUpdateParentFolder(folderIds, folderId){
        return this.api()
            .action('multi-update/parent-folder')
            .update({ folderIds: folderIds, folderId: folderId}, false);
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    restore(){
        return this.constructor.api().action('restore/' + this.id).getSingle();
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    destroy(){
        return this.api().delete();
    }

    /**
     *
     * @returns {boolean}
     */
    IsPreviewable(){
        return false;
    }

    /**
     *
     * @param term
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(term){
        return this.api().action('search')
            .where('term', term)
            .limit(100)
            .get().then( (response) => {
                let images = [];
                if(Array.isArray(response) && response.length > 0){
                    response.forEach((image) => {
                        images.push(new MediaLibraryDocument(image));
                    })
                }
                return images;
            });
    }

    /**
     *
     * @returns {boolean|*}
     */
    Item(){
        return MediaLibraryItem.find(this.media_library_item_id);
    }

    /**
     * alias since the name is ambiguous
     * @returns {boolean|*}
     */
    Folder() {
        return this.ParentFolder();
    }

    /**
     *  Media Library Actions (see constants and medialibrarycontextmenu for the action keys
     */

    /**
     *
     * @param context
     * @returns {*}
     */
    rename(context) {
        return context.$emit('openEditName', this.Item());
    }

    /**
     *
     * @param context
     * @returns {*}
     */
    editTags(context){
        return context.$emit('showEditTags', this.Item());
    }

    /**
     *
     * @param context
     * @returns {*}
     */
    move(context) {
        return context.$emit('openMoveItem', this.Item());
    }

    /**
     *
     * @param context
     * @returns {*}
     */
    download(context) {
        return context.$emit('downloadItem', this.Item());
    }

    /**
     *
     * @param context
     * @returns {*}
     */
    deleteItem(context){
        return context.$emit('deleteItem', this.Item());
    }
}
